import { omit, pick } from 'lodash';

import { initialState } from 'entities/creditForm';

// данный импорт будет исключен из сборки для production через webpack.IgnorePlugin
// eslint-disable-next-line import/no-internal-modules
import * as mock from '../../../../../__mocks__/creditForm';

export const mockData = {
  creditPurpose: {
    data: mock?.creditPurposeData || {},
    defaultData: initialState.creditPurposeForm.defaults,
    toolAddId: 'creditPurposeAddId',
    toolRemoveId: 'creditPurposeRemoveId',
  },
  contactsData: {
    data: mock?.contactsData || {},
    defaultData: omit(initialState.contactsForm.defaults, ['mobilePhone']),
    toolAddId: 'contactsInfoAddId',
    toolRemoveId: 'contactsInfoRemoveId',
  },
  passportData: {
    data: mock?.passportData || {},
    defaultData: initialState.passportForm.defaults,
    toolAddId: 'passportInfoAddId',
    toolRemoveId: 'passportInfoRemoveId',
  },
  workData: {
    data: mock?.workData || {},
    defaultData: initialState.workplaceForm.defaults,
    toolAddId: 'workInfoAddId',
    toolRemoveId: 'workInfoRemoveId',
  },
  additionalData: {
    data: mock?.additionalData || {},
    defaultData: initialState.additionalDataForm.defaults,
    toolAddId: 'additionalInfoAddId',
    toolRemoveId: 'additionalInfoRemoveId',
  },
  seoLandingData: {
    data: {
      ...(mock?.creditPurposeData || {}),
      ...(mock?.contactsData || {}),
      ...pick(mock?.passportData || {}, ['gender', 'fullName', 'region', 'regionLocationRoute']),
    },
    defaultData: {
      ...initialState.creditPurposeForm.defaults,
      ...omit(initialState.contactsForm.defaults, ['mobilePhone']),
      ...pick(initialState.passportForm.defaults, ['gender', 'fullName', 'region', 'regionLocationRoute']),
    },
    toolAddId: 'seoLandingDataAddId',
    toolRemoveId: 'seoLandingDataRemoveId',
  },
};
